import { forwardRef } from "react";


const StickyInnerContainer = forwardRef(({ children}, ref) => {
    return (<div ref={ref} className="sticky top-0 h-screen flex flex-row flex-nowrap">
        {children}
    </div>);
})
StickyInnerContainer.displayName = "StickyInnerContainer"

export default StickyInnerContainer;